import initialState from '../store/initial-state'
import {
  USERS,
  USERS_ALL_DATA,
  USERS_SUCCESS_ALL_DATA,
  USERS_FAILURE_ALL_DATA,
  USERS_EMPTY,
  USERS_SUCCESS,
  USERS_FAILURE,
  USERS_EXISTS,
  USERS_EXISTS_RESET,
  USERS_EXISTS_SUCCESS,
  USERS_EXISTS_FAILURE,
  USERS_INVITATION_ADD,
  USERS_INVITATION_ADD_SUCCESS,
  USERS_INVITATION_ADD_FAILURE,
  USERS_ADD,
  USERS_ADD_RESET,
  USERS_ADD_SUCCESS,
  USERS_ADD_FAILURE,
  USERS_EDIT,
  USERS_EDIT_SUCCESS,
  USERS_EDIT_FAILURE,
  USERS_DELETE,
  USERS_DELETE_SUCCESS,
  USERS_DELETE_FAILURE,
  USERS_EDIT_SELECT,
  USERS_EDIT_UNSET_SELECT,
  USERS_CHANGE_PASSWORD_SELECT,
  USERS_CHANGE_PASSWORD_UNSET_SELECT,
  USERS_CHANGE_PASSWORD,
  USERS_CHANGE_PASSWORD_SUCCESS,
  USERS_CHANGE_PASSWORD_FAILURE,
  APP_DRAWER_ENABLED,
  USERS_EXIST_GROUP,
  USERS_EXIST_GROUP_SUCCESS,
  USERS_EXIST_GROUP_FAILURE
} from '../constants/users-types'


export default (state = initialState.users, action) => {
  switch (action.type) {
    case USERS:
      return {
        ...state,
        isFetching: true,
        data: [],
        headers: null,
        error: null,
        newUser: ''
      }

    case USERS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
        headers: action.payload.headers,
        error: null
      }

    case USERS_FAILURE:
      return {
        ...state,
        isFetching: false,
        data: [],
        headers: null,
        error: action.payload
      }
    
    case USERS_ALL_DATA:
      return {
        ...state,
        isFetching: true,
        allUsers: [],
        headers: null,
        error: null,
        newUser: ''
      }

    case USERS_SUCCESS_ALL_DATA:
      return {
        ...state,
        isFetching: false,
        allUsers: action.payload.allUsers,
        headers: action.payload.headers,
        error: null
      }

    case USERS_FAILURE_ALL_DATA:
      return {
        ...state,
        isFetching: false,
        allUsers: [],
        headers: null,
        error: action.payload
      }

    case USERS_ADD_RESET:
      return {
        ...state,
        userAddIsFetching: false,
        userAddStatus: ''
      }

    case USERS_ADD:
      return {
        ...state,
        userAddIsFetching: true,
        userAddStatus: '',
        newUser: '',
        invitationIsFetching: true,
        invitationSent: false,
        invitationError: null
      }

    case USERS_ADD_SUCCESS:
      return {
        ...state,
        userAddIsFetching: false,
        userAddStatus: 'success',
        newUser: action.payload.newUser,
        invitationIsFetching: false,
        invitationSent: true
      }

    case USERS_ADD_FAILURE:
      return {
        ...state,
        userAddIsFetching: false,
        userAddStatus: 'error',
      }

    case USERS_EXISTS:
      return {
        ...state,
        userExistsIsFetching: true,
        userExists: '',
        userExistsProfile: '',
        userExistsWorkclientAlreadyDone: '',
        userExistsError: ''
      }

    case USERS_EXISTS_RESET:
      return {
        ...state,
        userExistsIsFetching: false,
        userExists: '',
        userExistsProfile: '',
        userExistsWorkclientAlreadyDone: '',
        userExistsError: ''
      }

    case USERS_EXISTS_SUCCESS:
      return {
        ...state,
        userExistsIsFetching: false,
        userExists: action.payload.status,
        userExistsProfile: action.payload.status === 'UserAlreadyExist'
          ? action.payload.profile
          : '',
        userExistsUserId: action.payload.status === 'UserAlreadyExist'
          ? action.payload.userId
          : '',
        userExistsWorkclientAlreadyDone: action.payload.status === 'UserAlreadyExist'
          ? action.payload.workclientAlreadyDone
          : '',
        userExistsError: ''
      }
    case USERS_EXISTS_FAILURE:
      return {
        ...state,
        userExistsIsFetching: false,
        userExists: '',
        userExistsProfile: '',
        userExistsWorkclientAlreadyDone: '',
        userExistsError: action.payload
      }

    case USERS_INVITATION_ADD:
      return {
        ...state,
        invitationIsFetching: true,
        invitationSent: false,
        invitationError: null
      }

    case USERS_INVITATION_ADD_SUCCESS:
      return {
        ...state,
        invitationIsFetching: false,
        invitationSent: true
      }

    case USERS_INVITATION_ADD_FAILURE:
      return {
        ...state,
        invitationIsFetching: false,
        invitationSent: false,
        invitationError: action.payload
      }


    case USERS_EDIT_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isEditSelected: r._id === action.payload._id
              ? true
              : false
          }
        })]
      }

    case USERS_EDIT_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isEditSelected: false,
          }
        })]
      }

    case USERS_EDIT:
      return {
        ...state,
        isUpdating: true,
        editError: null
      }

    case USERS_EDIT_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        updated: true,
        data: [...state.data.map(r => {
          return {
            ...r,
            clientRole: r._id === action.payload.id
              ? action.payload.role
              : r.role
          }
        })]
      }

    case USERS_EDIT_FAILURE:
      return {
        ...state,
        isUpdating: false,
        editError: action.payload.error
      }

    case USERS_DELETE:
      return {
        ...state,
        isDeleting: true,
        deleteStatus: 'none'
      }

    case USERS_DELETE_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        deleteStatus: 'success'
      }
    case USERS_DELETE_FAILURE:
      return {
        ...state,
        isDeleting: false,
        deleteStatus: 'failed'
      }

    case USERS_EMPTY:
      return {
        ...state,
        editError: null,
        headers: null,
        allUsers: null,
        data: [],
        error: null,
        userAddIsFetching: false,
        userAddStatus: '',
        newUser: '',
        invitationIsFetching: false,
        invitationSent: false,
        invitationError: null
      }
    case USERS_CHANGE_PASSWORD_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isChangePasswordSelected: r._id === action.payload._id
              ? true
              : false
          }
        })]
      }

    case USERS_CHANGE_PASSWORD_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isChangePasswordSelected: false,
          }
        })]
      }

    case USERS_CHANGE_PASSWORD:
      return {
        ...state,
        isChangingPassword: true
      }

    case USERS_CHANGE_PASSWORD_FAILURE:
      return {
        ...state,
        isChangingPassword: false
      }

    case USERS_CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isChangePasswordSelected: false,
          }
        })],
        isChangingPassword: false
      }
    case APP_DRAWER_ENABLED:
      return {
        ...state,
        drawerdEnable: action.payload
      }
    case USERS_EXIST_GROUP:
      return {
        ...state,
        userExistsStatus: '',
        newUser: ''
      }
    case USERS_EXIST_GROUP_SUCCESS:
      return {
        ...state,
        userExistsStatus: 'success',
        newUser: action.payload.newUser
      }
    case USERS_EXIST_GROUP_FAILURE:
      return {
        ...state,
        userExistsStatus: 'failure',
        newUser: ''
      }


    default: return { ...state }
  }
}
